import * as React from 'react';
import { clsx } from 'clsx';
import { InputWrapperInput } from '../../../../internal/components/InputWrapperInput/InputWrapperInput';
import { FocusObserver } from '../../../../internal/components/FocusObserver/FocusObserver';
import { FocusSource } from '../../../../internal/types';
import styles from './styles.module.css';
import { useMouseFocus } from '../../hooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const StepperField = props => {
  const {
    invalid,
    dataTestId,
    value,
    decrementButton,
    disabled,
    fullWidth,
    incrementButton,
    size,
    step,
    min,
    max,
    onChange,
    onKeyDown,
    onBlur,
    onKeyboardFocus
  } = props;
  const [focus, setFocus] = React.useState({
    focused: false,
    source: FocusSource.mouse
  });
  const {
    isMouseFocus,
    handleBlur,
    handleMouseFocus
  } = useMouseFocus();
  const isKeyboardFocus = focus.source === FocusSource.keyboard;
  const controlsClasses = clsx(styles['stepper-controls'], {
    [styles['stepper-controls--fullWidth']]: fullWidth,
    [styles['stepper-controls--fixed']]: !fullWidth,
    [styles["stepper-controls--".concat(size)]]: size,
    [styles['stepper-controls--invalid']]: invalid && !disabled,
    [styles['stepper-controls--disabled']]: disabled,
    [styles['focused_keyboard']]: isKeyboardFocus,
    [styles['stepper-controls--mouseFocus']]: isMouseFocus && !invalid
  });
  const handleFocus = (focused, source) => {
    setFocus({
      focused,
      source
    });
    if (focused && source === FocusSource.keyboard) {
      onKeyboardFocus();
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: controlsClasses,
    onKeyDown: onKeyDown,
    role: "group",
    tabIndex: -1,
    onFocus: handleMouseFocus,
    onBlur: handleBlur,
    "data-testid": "".concat(dataTestId, "-controls"),
    children: [/*#__PURE__*/_jsx(FocusObserver, {
      onFocus: handleFocus,
      children: /*#__PURE__*/_jsx(InputWrapperInput, {
        type: "tel",
        inputMode: step % 1 === 0 ? 'numeric' : 'decimal',
        max: max,
        min: min,
        step: step,
        value: value,
        disabled: disabled,
        className: styles['stepper-input'],
        "data-mark": "StepperInput",
        onChange: onChange,
        onBlur: onBlur
      })
    }), decrementButton, incrementButton]
  });
};